import { render, staticRenderFns } from "./NumerationGridComponent.vue?vue&type=template&id=46fd9b10"
import script from "./NumerationGridComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./NumerationGridComponent.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46fd9b10')) {
      api.createRecord('46fd9b10', component.options)
    } else {
      api.reload('46fd9b10', component.options)
    }
    module.hot.accept("./NumerationGridComponent.vue?vue&type=template&id=46fd9b10", function () {
      api.rerender('46fd9b10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Numeration/NumerationGridComponent.vue"
export default component.exports